import React, {useEffect} from "react";
import InnerEquipe from './InnerEquipe';
import Queries from 'utils/Queries';
import { useQuery } from '@apollo/client';
import './Equipe.scss'

function Equipe() {
  const { data,refetch } = useQuery(Queries.equipe);
  useEffect(()=>{
    refetch();
  },[refetch]);
  const equipe=data && data.equipe ? data.equipe : {};
  return <InnerEquipe equipe={equipe}/>;
}
export default Equipe;
